import React, { useRef } from 'react';
import s from '../Header.module.css';
import useClickOutside from '../../../hooks/useClickOutside';
import { PrismicImage, PrismicText } from '@prismicio/react';
import { asText } from '@prismicio/client';
// import airdaoIcon from '../assets/airdao.svg';
import TailArrow from '../../Icons/TailArrow';
export function MobileMenu(_a) {
    var close = _a.close, isOpen = _a.isOpen, data = _a.data, balance = _a.balance;
    var ref = useRef(null);
    useClickOutside(ref, close, isOpen);
    var isActive = function (productName) {
        return window.location.pathname.includes(productName.toLowerCase());
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['mobile-menu'], ref: ref },
            React.createElement("div", { className: s['connected-nav__link-arrow'] },
                React.createElement("a", { href: "/", className: s['connected-nav__product'] }, "Get AMB"),
                React.createElement(TailArrow, null)),
            data &&
                data.products.map(function (product) { return (React.createElement("a", { href: product === null || product === void 0 ? void 0 : product.url, className: "".concat(s['mobile-menu__link'], " ").concat(isActive(asText(product.name))
                        ? s['mobile-menu__link_active']
                        : '') },
                    React.createElement(PrismicText, { field: product.name }))); }),
            data &&
                data.submenus.map(function (submenu) { return (React.createElement("div", { className: s['mobile-menu__sublist'] },
                    React.createElement("div", { className: s['mobile-menu__sublist-name'] },
                        React.createElement(PrismicText, { field: submenu.name })),
                    React.createElement("div", { className: s['mobile-menu__sublist-content'] }, submenu.content.map(function (item) { return (React.createElement("a", { href: item.url, target: item.target, key: item.name, className: s['mobile-menu__sublist-link'] },
                        React.createElement(PrismicText, { field: item.name }))); })))); }),
            React.createElement("div", { className: s['mobile-menu__divider'] }),
            React.createElement("div", { className: s['mobile-menu__socials'] },
                React.createElement("div", { className: s['mobile-menu__socials-name'] }, "Community"),
                React.createElement("div", { className: s['mobile-menu__socials-content'] }, data &&
                    data.socials.map(function (social) { return (React.createElement("a", { href: social.url, target: social.target, rel: "nofollow", className: s['mobile-menu__socials-link'] },
                        React.createElement(PrismicImage, { field: social.img, className: s['mobile-menu__social-img'] }))); }))))));
}
//# sourceMappingURL=MobileMenu.js.map